module.exports = __webpack_public_path__ + "img/file-earmark-text.104aecf4.svg";